//testUrl:测试环境的地址
//let testUrl = '/richin/test';
let testUrl = 'http://110.41.7.145:8088';

export { testUrl };
